import { JQElementHelper } from "../lib/JQElementHelper";
import { AxDropdownEvents } from "./lib/AxDropdownEvents";
export var Direction;
(function (Direction) {
    Direction[Direction["added"] = 0] = "added";
    Direction[Direction["removed"] = 1] = "removed";
})(Direction || (Direction = {}));
export class AxDropdown {
    constructor(jqElementHelper = new JQElementHelper()) {
        this.jqElementHelper = jqElementHelper;
        this.defaultOptions = { searchBar: false, multiSelect: false, hideOnOutOfScreen: true };
    }
    /**
     * Init AxDropdown.
     *
     * @remarks
     * As soon as init is called menu is removed from DOM
     *
     * @param selector - Javascript QuerySelector
     * @param options -
     *  - onSelect: on new selected element return parent and selected element, in case of multiselect all selected elements
     *  - onChange: with multiselect false, same behavior as onSelect bad called twice (one selected, one unselected),
     *          with multiselect true called on every change
     *              return parent and selected element, in case of multiselect all selected elements, effected element
     */
    init(selector, options) {
        this.selector = selector;
        this.options = Object.assign(Object.assign({}, this.defaultOptions), options);
        this.axDropdownEvents = new AxDropdownEvents(selector, this.options);
    }
    getElements() {
        return this.axDropdownEvents.$parents;
    }
    toggleMenu($parent) {
        $parent = $parent || $(this.selector);
        let instance = this.axDropdownEvents.interaction.getTippyInstance($parent);
        if (instance.state.isVisible) {
            this.axDropdownEvents.interaction.close($parent);
        }
        else {
            this.axDropdownEvents.interaction.open($parent);
        }
    }
    open($parent) {
        $parent = $parent || $(this.selector);
        this.axDropdownEvents.interaction.open($parent);
    }
    close($parent) {
        $parent = $parent || $(this.selector);
        this.axDropdownEvents.interaction.close($parent);
    }
    select($elem) {
        const $parent = this.getParent($elem);
        this.axDropdownEvents.interaction.select($elem, $parent);
    }
    resetSelection($parent) {
        $parent = $parent || $(this.selector);
        $parent.each((i, e) => {
            this.axDropdownEvents.interaction.resetSelection($(e));
        });
    }
    getSelected($parent) {
        $parent = $parent || this.getParent(null);
        let instance = this.axDropdownEvents.interaction.getTippyInstance($parent);
        return $(instance.popper).find('.ax-dropdown__menu .ax-dropdown__item.selected');
    }
    getValue($parent) {
        $parent = $parent || this.getParent(null);
        return this.axDropdownEvents.interaction.getValue($parent);
    }
    setValue(value, $parent) {
        $parent = $parent || this.getParent(null);
        return this.axDropdownEvents.interaction.setValue(value, $parent);
    }
    val() {
        return this.getValue();
    }
    getOpenObserver() {
        return this.axDropdownEvents.interaction.openSubject;
    }
    getOnShownObserver() {
        return this.axDropdownEvents.interaction.onShownSubject;
    }
    getSelectObserver() {
        return this.axDropdownEvents.interaction.changeSubject;
    }
    /// <summary>
    /// 
    /// </summary>
    /// <param name="option">Jquery element or string value of option</param>
    /// <param name="disabled">null for toggle</param>
    /// <param name="$parent">Optional - parent</param>
    /// <returns>new state of options</returns>
    toggleDisabled(option, disabled, $parent) {
        $parent = $parent || this.getParent(null);
        return this.axDropdownEvents.interaction.toggleDisabled(option, disabled, $parent);
    }
    getParent($elem) {
        var $elements = this.getElements();
        if ($elements.length === 1) {
            return $($elements[0]);
        }
        if ($elem !== null && $elem.length > 0) {
            for (let parent of $elements) {
                let $parent = $(parent);
                if ($parent.has($elem[0]).length > 0) {
                    return $parent;
                }
            }
        }
        return $($elements[0]);
    }
    jumpToElement($parent) {
        $([document.documentElement, document.body]).animate({
            scrollTop: $parent.offset().top - 100
        }, 100);
    }
    validate(scrollToElement = false) {
        //placeholder
        // for (let dropdown of this.Dropdowns) {
        //     const element = $(dropdown.ValueElem);
        //     const formGroup = element.closest('.ax-form-group');
        //     if (dropdown.ValueElem.innerHTML == '') {
        //         if (formGroup.length > 0) {
        //             $(formGroup).addClass('invalid-form');
        //             if (scrollToElement) {
        //                 this.JumpToElement();
        //             }
        //         }
        //         return false;
        //     } else {
        //         if (formGroup.length > 0) {
        //             $(formGroup).removeClass('invalid-form');
        //         }
        //     }
        // }
        return true;
    }
    getSelector() {
        return this.selector;
    }
}
// Override expression to make it case insensitive
// @ts-ignore
jQuery.expr[":"].contains = function (a, i, m) {
    return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
};
